import { VField } from "../../components/Fields/Fields"
import { Gestore, Scheda } from "../../types"
import { useFormikContext } from "formik"
import { FormUser } from "./types"
import { useEffect } from "react";
import { useAuth } from "../../auth";

export default function FormUtente({ gestori, schede }: { gestori: Gestore[]; schede: Scheda[] }) {

  const { values, setFieldValue } = useFormikContext<FormUser>()
  const { user } = useAuth()

  useEffect (() => {
    if (!values.restrizioni_documentale) {
      setFieldValue("schede_documentale_abilitate", []);
    }
  }, [values.restrizioni_documentale]);

  return (
    <>
      <div className="row">
        <div className="col-6">
          <VField name="full_name" label="Nome e Cognome" type="text" required />
        </div>
        <div className="col-6">
          <VField name="email" label="Email" type="email" required />
        </div>
        <div className="col-6">
          <VField name="gestore" label="Gestore" as="select" required>
            <option value="">Seleziona un ruolo</option>
            {gestori.map((gestore) => {
              return (
                <option key={gestore.id} value={gestore.id}>
                  {gestore.descrizione}
                </option>
              )
            })}
            <option value={"comune"}>Comune</option>
          </VField>
        </div>
        <div className="row">
          <div className="col-6">
            <VField name="restrizioni_documentale" label="Restrizioni documentale" type="checkbox" required  disabled={!user?.is_staff} />
          </div>
          <div className="col-6">
            <VField
              name="schede_documentale_abilitate"
              label={`Schede abilitate (${values.schede_documentale_abilitate?.length || 0})`}
              as="select"
              multiple
              disabled={!values.restrizioni_documentale || !user?.is_staff}
            >
              {schede.map((scheda) => {
                return (
                  <option key={scheda.id} value={scheda.id}>
                    {scheda.titolo}
                  </option>
                )
              })}
            </VField>
          </div>
        </div>
      </div>
    </>
  )
}
